import Component, { QUERY } from 'components/pages/Deals/Deals';
import { PROMOTION_TAG } from 'utils/offers';
import { buildPage, buildQueryPreloader } from 'utils/pageHelper';

export default buildPage(Component, {
  metaData: {
    title: 'Deals',
    description:
      'Find deals and money saving coupons on the biggest brands around or just let us show you ones you’ll like.',
  },
});
export const getStaticProps = buildQueryPreloader(QUERY, {
  requiredTags: [],
  promoTags: [PROMOTION_TAG],
});
